<template>
  <el-select
    v-model="localValue"
    :size="size"
    :multiple="multiple"
    remote
    clearable
    :filterable="filterable"
    reserve-keyword
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    @visible-change="$event ? remoteMethod() : null"
    :loading="loading"
  >
<!--    <div-->
<!--      v-loading="loading"-->
<!--      v-infinite-scroll="nextPage"-->
<!--      :infinite-scroll-immediate="false"-->
<!--      :infinite-scroll-delay="100"-->
<!--    >-->
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.full_name"
        :value="item.id"
      >
      </el-option>
<!--    </div>-->
  </el-select>

</template>

<script>


import {paginator} from "@/mixins/paginator";
import requestSender from "@/api/base/requestSender";

export default {
  name: "user-procedure-all-subordinates-select",
  mixins: [paginator],
  components: {},
  props: {
    value: {},
    size: {type: String, default: ''},
    placeholder: {type: String, default: ''},
    multiple: {type: Boolean, default: false},
    filterable: {type: Boolean, default: false},

    procedureId: {type: Number, required: true},
    userId: {type: Number, required: true},
  },

  data() {
    return {
      loading: false,
      query: null,
      page: 1,
      options: [],
    }
  },
  mounted() {
    // this.remoteMethod()
  },
  watch: {},
  computed: {
    localValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.selected(newValue)
      }
    }
  },
  methods: {
    remoteMethod(query) {
      this.query = query;
      // this.page = 1;
      if( this.options.length ){
        return;
      }
      this.getData();
    },

    nextPage(){
      this.page++;
      this.getData();
    },

    getData() {
      this.loading = true;
      requestSender('get', 'compensation-procedure/get-users-tree', {
        procedure_id: this.procedureId,
        parent_user_id: this.userId,
        all_subordinates: 1,
      })
        .then(data => {
          this.options = data.users;
        })
        .finally(() => {
          this.loading = false;
        })
    },

    selected(value) {
      this.$emit('input', value);
      this.$emit('selected', value)
    }
  },

}
</script>


<style scoped>

</style>